import { TabsProps } from '@app/types'
import { Tabs as AntTabs } from 'antd'
import styled from 'styled-components'

const StyledTabs = styled(AntTabs)`
  .ant-tabs-nav-list {
    display: flex;
  }

  .ant-tabs-tab {
    justify-content: center;
    margin: 0 !important;
    padding-inline: 16px;
    position: relative;
  }

  .ant-tabs-ink-bar {
    display: none;
  }

  .ant-tabs-tab-active::after {
    background: currentColor;
    bottom: 0;
    content: '';
    height: 2px;
    left: 16px;
    position: absolute;
    right: 16px;
  }
`

export const Tabs: React.FC<TabsProps> = (props) => (
  <StyledTabs animated={{ inkBar: false, tabPane: false }} {...props} />
)
